/**
 * REQUIRED BACKEND/BUSINESS CONFIGURATION.
 * Common-list targets have IDs 1..9, but the supplied samples contain no
 * authoritative Target -> Division mapping. Populate only after approval.
 * Example syntax: 1: 'IIT Division', 2: 'IIT Division'.
 * An empty mapping deliberately blocks misleading division-level reports.
 */
export const TARGET_TO_DIVISION = Object.freeze({});

export const divisionOptions = (targets) => {
  const values = new Set();
  targets.forEach((target) => {
    const division = TARGET_TO_DIVISION[String(target.target_id)];
    if (division) values.add(division);
  });
  return [...values].sort().map((division) => ({ value: division, label: division }));
};

export const targetIdsForDivision = (targets, division) => targets
  .filter((target) => TARGET_TO_DIVISION[String(target.target_id)] === division)
  .map((target) => target.target_id);
